import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import BaseForm from '../Form';
import ModalAuthorization from './ModalAuthorization';

import Input from '../../../ui/Form/Input';
import Text from '../../../ui/Text';
import DialogModal from '../../../ui/DialogModal';

import { fetchCompanies } from '../../../../store/sngpc/actions';
import { AppState } from '../../../../store/index';

import { AuthenticationSngpcData } from '../../../../interfaces/authentication';

import * as Styles from './FormLoginSngpcStyles';

const validate = (values: AuthenticationSngpcData): Partial<AuthenticationSngpcData> => {
  const errors: Partial<AuthenticationSngpcData> = {};

  if (!values.email) {
    errors.email = 'O e-mail é obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'E-mail inválido';
  }

  if (!values.password) {
    errors.password = 'A senha é obrigatória';
  } else if (!values.password.trim()) {
    errors.password = 'Senha inválida';
  }

  return errors;
};

const Form: React.FC = () => {
  const dispatch = useDispatch();

  const { currentStep, loading, error } = useSelector((state: AppState) => state.sngpc);

  const [isShow, setIsShow] = useState<boolean>(false);
  const [passwordShow, setPasswordShow] = useState(false);

  const showError = (inputName: keyof AuthenticationSngpcData): boolean =>
    Boolean(form.errors[inputName] && form.touched[inputName]);

  const form = useFormik<AuthenticationSngpcData>({
    initialValues: {
      email: '',
      password: '',
    },
    validate,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsShow(true);
    },
  });

  const handleCancelModal = (): void => setIsShow(false);

  const handleAuthorizedModal = async (): Promise<void> => {
    try {
      setIsShow(false);
      dispatch(fetchCompanies({ email: form.values.email, password: form.values.password }));
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.error(err?.message);
    }
  };

  const togglePasswordVisiblity = (): void => {
    setPasswordShow(!passwordShow);
  };

  return (
    <Styles.Container>
      <DialogModal show={isShow}>
        <ModalAuthorization handleCancel={handleCancelModal} handleAuthorized={handleAuthorizedModal} />
      </DialogModal>

      <Styles.Header>
        <Styles.Title>Informações SNGPC</Styles.Title>
        <Text color="black80" align="justify">
          Insira seu e-mail e senha do SNGPC para resgatar os dados cadastrais de sua farmácia e facilitar o processo de
          cadastro na Memed.
        </Text>
      </Styles.Header>

      <BaseForm onSubmit={form.handleSubmit} loading={loading} error={error} step={currentStep}>
        <Input
          required
          onInputChange={form.handleChange}
          errors={showError('email') ? form.errors.email : undefined}
          name="email"
          label="E-mail"
          type="text"
          placeholder="Seu e-mail do SNGPC"
        />

        <Input
          required
          onInputChange={form.handleChange}
          errors={showError('password') ? form.errors.password : undefined}
          name="password"
          label="Senha"
          type={passwordShow ? 'text' : 'password'}
          placeholder="Sua senha do SNGPC"
          passwordHandlers={{
            passwordShow,
            handlePasswordVisibility: () => togglePasswordVisiblity(),
          }}
        />
      </BaseForm>
    </Styles.Container>
  );
};

export default Form;
